import { render } from "./Counterman.vue?vue&type=template&id=2643a574&scoped=true"
import script from "./Counterman.vue?vue&type=script&lang=js"
export * from "./Counterman.vue?vue&type=script&lang=js"

import "./Counterman.vue?vue&type=style&index=0&id=2643a574&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2643a574"]])

export default __exports__